import { buildCatalog, type GuideCatalog } from './catalog';

/** Prefisso delle chiavi di `import.meta.glob`: la sorgente del manuale (DEC-011, FED-002). */
const MANUAL_ROOT = '../../../../docs/manuale/operatori/';

/**
 * Il Markdown del manuale, letto da Vite alla build (FED-002): nessuna copia a mano, una modifica
 * ai file è nella build successiva (e subito, con il dev server). Il README delle convenzioni non è
 * una pagina della Guida.
 */
const RAW_FILES = import.meta.glob<string>(
  ['../../../../docs/manuale/operatori/**/*.md', '!../../../../docs/manuale/operatori/README.md'],
  { eager: true, query: '?raw', import: 'default' }
);

/** I file del manuale per percorso relativo a `docs/manuale/operatori/`. */
export const GUIDE_FILES: Readonly<Record<string, string>> = Object.fromEntries(
  Object.entries(RAW_FILES).map(([key, markdown]) => [key.slice(MANUAL_ROOT.length), markdown])
);

/** Il catalogo della Guida costruito dai file del manuale. */
export const GUIDE: GuideCatalog = buildCatalog(GUIDE_FILES);
